import { FF } from 'modules/feature-flags/featureFlags.generated';
import { useSplitFlag } from 'modules/feature-flags/useSplitFlag';
import { useMemo } from 'react';
import { CacheStrategy } from 'modules/viewer/PixelCacheStategy';
import { ViewerDownloadingFlags } from 'modules/viewer/workers/pixelDataSharedWorkerTypes';

export function useViewerDownloadingFlags(): [ViewerDownloadingFlags, boolean] {
  const [cacheStrategy, loadingCacheStrategy] = useSplitFlag<CacheStrategy>(
    FF.VIEWER_CACHE_STRATEGY
  );

  return useMemo(() => {
    return [
      {
        cacheStrategy,
      },
      loadingCacheStrategy,
    ];
  }, [cacheStrategy, loadingCacheStrategy]);
}
